import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AOTUser } from "../../models/userProfile";

@Injectable({
    providedIn: 'root'
})
export class AdminResolverService {
    private API_URL: string = ''
    constructor(private readonly http:HttpClient){
        this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
    }
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AOTUser[]> {
        return this.http.get<AOTUser[]>(this.API_URL+'/api/people-management/users/bytoken')
    }
}